import { listStylesReset } from '../../../../jss';
import {
    MORE_984_MEDIA_QUERY,
    MORE_1024_MEDIA_QUERY
} from '../../../../consts/adaptive';


export const styles = {
    container: {
        ...listStylesReset,
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: [0, 20],
        width: '100%',
        height: 60,
        overflowX: 'auto',
        fontSize: 14,
        lineHeight: '20px',
        color: '#8b572a',
        backgroundColor: '#fff9b1'
    },
    item: {
        position: 'relative',
        display: 'inline-flex',
        flexShrink: 0,
        paddingLeft: 12,
        paddingRight: 13,

        '&:last-child': {
            position: 'static',
            paddingRight: 0,

            '&::after': {
                display: 'none'
            }
        },

        '&:first-child': {
            paddingLeft: 0
        },

        '&::after': {
            content: '""',
            position: 'absolute',

            top: 5,
            right: 0,
            width: 1,
            height: 11,
            backgroundColor: 'currentColor'
        }
    },
    [MORE_984_MEDIA_QUERY]: {
        container: {
            position: 'initial',
            height: 'auto',
            padding: [20, 8],
            overflowX: 'initial'
        },
        item: {
            '&:first-child': {
                paddingLeft: 12
            },
            '&::after': {
                top: 7
            }
        }
    },
    [MORE_1024_MEDIA_QUERY]: {
        item: {
            paddingLeft: 20
        }
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
